import { ArrowDirectionType } from '@interface/common';

export const TOP: ArrowDirectionType = 'top';
export const BOTTOM: ArrowDirectionType = 'bottom';
export const LEFT: ArrowDirectionType = 'left';
export const RIGHT: ArrowDirectionType = 'right';
